<template>
  <main class="no-access-container h-dvh w-dvw flex items-center justify-center">
    <NoAccessPage
      v-if="error.statusCode === 401"
      :content-type="error.data?.contentType"
      :content-id="error.data?.id"
    />
    <div v-else class="text-center text-white">
      <h1 class="text-4xl font-bold mb-4">{{ error.statusCode }}</h1>
      <p class="text-xl">{{ error.statusMessage || 'An error occurred' }}</p>
    </div>
  </main>
</template>

<script lang="ts" setup>
definePageMeta({
  layout: 'blank',
})

const route = useRoute()

defineProps<{
  error: {
    statusCode: number
    statusMessage?: string
    data?: {
      contentType?: string
      id?: string | number
    }
  }
}>()
</script>

<style scoped>
.no-access-container {
  background: linear-gradient(180deg, #082f49 0%, #0c4a6e 50%, #082f49 100%), #fff;
}

:deep(.separator > span) {
  background-color: #0c4a6e;
}
</style>
